{
  "ADD_NEW_BOOKING_TAB_TITLE": "Neue Buchung",
  "AFTER_SALES_DETAIL_ACCORDION_TITLE_RECOURSE_BOOKINGS": "Buchungen",
  "AFTER_SALES_DETAIL_ACCORDION_TITLE_RECOURSE_COST": "Regresskosten",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_BODY_NO_DATA": "Keine Zusatzkosten vorhanden",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_CATEGORY": "Kategorie",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_COMMENT": "Beschreibung",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_EUR": "Zusatzkosten [€]",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_DIALOG_TITLE": "Zusatzkosten bearbeiten",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_CATEGORY": "Kategorie",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_COMMENT": "Beschreibung",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_HEADER_EUR": "Zusatzkosten [€]",
  "AFTER_SALES_DETAIL_ADDITIONAL_COST_SUM": "Summe Zusatzkosten [€]:",
  "AFTER_SALES_DETAIL_BUTTON_ADDITIONAL_COST": "Zusatzkosten",
  "AFTER_SALES_DETAIL_BUTTON_CREATE_MANUAL_BOOKING": "Manuelle Buchung erstellen",
  "AFTER_SALES_DETAIL_CREATE_DATE": "Angelegt am",
  "AFTER_SALES_DETAIL_ERROR_CLASS": "Fehlerklasse",
  "AFTER_SALES_DETAIL_ERROR_CODE": "Fehlercode",
  "AFTER_SALES_DETAIL_ERROR_DESCRIPTION": "Fehlerbeschreibung",
  "AFTER_SALES_DETAIL_RECOURSE_COST_RATE": "Regresskostensatz [€]:",
  "AFTER_SALES_DETAIL_RECOURSE_RELEVANT": "Regressrelevant",
  "AFTER_SALES_DETAIL_REPORT_NO": "Meldung",
  "AFTER_SALES_DETAIL_REPORT_STATE": "Status Prüfbericht",
  "AFTER_SALES_DETAIL_SUPPLIER": "Lieferantennummer",
  "AFTER_SALES_DETAIL_SUPPLIER_NAME": "Lieferantenname",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_AMOUNT": "Betrag",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_BOOKING_TYPE": "Buchungsart",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_CREDITOR": "Kreditor",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_CREDITOR_NO": "Kreditor-Nr.",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_DUE_DATE": "Fälligkeitsdatum",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_ID": "Beleg-Nr.",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_STATE": "Status",
  "AFTER_SALES_DETAIL_TABLE_BOOKING_TOTAL_AMOUNT": "Gesamtwert:",
  "AFTER_SALES_DETAIL_TOTAL_COST": "Summe Regresskosten [€]:",
  "AFTER_SALES_DETAILS_TAB": "Details",
  "AFTER_SALES_ERROR_COST_RATE_CREATE_NEW_BUTTON": "Fehlerkostensatz hinzufügen",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_COST_RATE_EUR": "Kostensatz [€]",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_CLASS": "Fehlerklasse",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_CODE": "Fehlercode",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_ERROR_DESC": "Beschreibung",
  "AFTER_SALES_ERROR_COST_RATE_DIALOG_TITLE": "Fehlerkostensatz hinzufügen/bearbeiten",
  "AFTER_SALES_ERROR_COST_RATE_TAB": "Fehlerkostensätze",
  "AFTER_SALES_OVERVIEW_TAB": "Übersicht",
  "AFTER_SALES_SUPPLIER_EXCEPTIONS_EXCEL_FILENAME": "Lieferantenausschluss",
  "AFTER_SALES_SUPPLIER_EXCEPTIONS_TAB": "Lieferantenausschluss",
  "AFTER_SALES_TAB": "After Sales",
  "AFTER_SALES_TAB_TITLE": "Übersicht",
  "AFTER_SALES_TABLE_ADDITIONAL_COST": "Sum. Zu.kosten",
  "AFTER_SALES_TABLE_CREATE_DATE": "Ang. am",
  "AFTER_SALES_TABLE_DESCRIPTION": "Beschr.",
  "AFTER_SALES_TABLE_ERROR_CLASS": "Fehl.klasse",
  "AFTER_SALES_TABLE_ERROR_CODE": "Fehl.code",
  "AFTER_SALES_TABLE_ERROR_COST_ERROR_CLASS": "Fehlerkasse",
  "AFTER_SALES_TABLE_ERROR_COST_ERROR_DESCRIPTION": "Beschreibung",
  "AFTER_SALES_TABLE_ERROR_COST_ERROR_ID": "Fehlercode",
  "AFTER_SALES_TABLE_ERROR_COST_RATE": "Kostensatz",
  "AFTER_SALES_TABLE_RECOURSE_COST_RATE": "Regr.kost.satz",
  "AFTER_SALES_TABLE_RECOURSE_RELEVANT": "Regr.rel.",
  "AFTER_SALES_TABLE_REPORT_NO": "Meld.",
  "AFTER_SALES_TABLE_REPORT_STATE": "Stat.Meld.",
  "AFTER_SALES_TABLE_SUPPLIER": "Lief.",
  "AFTER_SALES_TABLE_SUPPLIER_ID": "Lief.-Nr.",
  "AFTER_SALES_TABLE_TOOLTIP_ADDITIONAL_COST": "Summe Zusatzkosten",
  "AFTER_SALES_TABLE_TOOLTIP_CREATE_DATE": "Angelegt am",
  "AFTER_SALES_TABLE_TOOLTIP_DESCRIPTION": "Beschreibung",
  "AFTER_SALES_TABLE_TOOLTIP_ERROR_CLASS": "Fehlerklasse",
  "AFTER_SALES_TABLE_TOOLTIP_ERROR_CODE": "Fehlercode",
  "AFTER_SALES_TABLE_TOOLTIP_RECOURSE_COST_RATE": "Regresskostensatz",
  "AFTER_SALES_TABLE_TOOLTIP_RECOURSE_RELEVANT": "Regressrelevant",
  "AFTER_SALES_TABLE_TOOLTIP_REPORT_NO": "Meldung",
  "AFTER_SALES_TABLE_TOOLTIP_REPORT_STATE": "Status Meldung",
  "AFTER_SALES_TABLE_TOOLTIP_SUPPLIER": "Lieferantenname",
  "AFTER_SALES_TABLE_TOOLTIP_SUPPLIER_ID": "Lieferantennummer",
  "AFTER_SALES_TABLE_TOOLTIP_TOTAL_COST": "Summe Regresskosten",
  "AFTER_SALES_TABLE_TOTAL_COST": "Sum.Regr.kost.",
  "AFTERSALES": "Aftersales",
  "AG_GRID_NO_ATTACHMENTS": "Keine Anhänge vorhanden",
  "AG_GRID_NO_BOOKINGS": "Keine Buchungen vorhanden",
  "AG_GRID_NO_ROWS": "Keine Zeilen vorhanden",
  "ag-grid.andCondition": "UND",
  "ag-grid.applyFilter": "Filter anwenden",
  "ag-grid.area": "Bereich",
  "ag-grid.areaChart": "Bereichsdiagramm",
  "ag-grid.areaGroup": "Bereichsgruppe",
  "ag-grid.automatic": "Automatisch",
  "ag-grid.autosizeAllColumns": "Alle Spaltenbreiten automatisch anpassen",
  "ag-grid.autosizeThiscolumn": "Spaltenbreite automatisch anpassen",
  "ag-grid.avg": "Durchschnitt",
  "ag-grid.axis": "Längsachse",
  "ag-grid.background": "Hintergrund",
  "ag-grid.barChart": "Balken",
  "ag-grid.barGroup": "Balkengruppe",
  "ag-grid.blanks": " ",
  "ag-grid.blur": "Unschärfe",
  "ag-grid.bold": "Fett",
  "ag-grid.boldItalic": "Fett Kursiv",
  "ag-grid.bottom": "Unten",
  "ag-grid.bubble": "Blase",
  "ag-grid.bubbleTooltip": "Blase",
  "ag-grid.callout": "Callout",
  "ag-grid.categories": "Kategorien",
  "ag-grid.category": "Kategorie",
  "ag-grid.chart": "Chart",
  "ag-grid.chartRange": "Diagramm Bereich",
  "ag-grid.clearFilter": "Filter leeren",
  "ag-grid.collapseAll": "Zuklappen",
  "ag-grid.color": "Farbe",
  "ag-grid.columnChart": "Spalte",
  "ag-grid.columnGroup": "Spaltengruppe",
  "ag-grid.columns": "Spalten",
  "ag-grid.contains": "Enthält",
  "ag-grid.copy": "Kopieren",
  "ag-grid.copyWithHeaders": "Kopieren mit Kopfzeilen",
  "ag-grid.count": "Zähler",
  "ag-grid.csvExport": "CSV Export",
  "ag-grid.ctrlC": "Strg + C",
  "ag-grid.ctrlV": "Strg + V",
  "ag-grid.data": "Daten",
  "ag-grid.dateFormatOoo": "yyyy-mm-dd",
  "ag-grid.defaultCategory": "(Keine)",
  "ag-grid.doughnut": "Donut",
  "ag-grid.doughnutTooltip": "Donut",
  "ag-grid.enabled": "Aktiviert",
  "ag-grid.endsWith": "Endet mit",
  "ag-grid.equals": "Gleich",
  "ag-grid.excelExport": "Excel Export (.xlsx)",
  "ag-grid.excelXmlExport": "Excel Export (.xml)",
  "ag-grid.expandAll": "Aufklappen",
  "ag-grid.export": "Exportieren",
  "ag-grid.fillOpacity": "Deckkraft Füllung",
  "ag-grid.filteredRows": "Gefilterte Zeilen",
  "ag-grid.filterOoo": "Filtern...",
  "ag-grid.filters": "Filter",
  "ag-grid.first": "Erste",
  "ag-grid.font": "Font",
  "ag-grid.format": "Format",
  "ag-grid.greaterThan": "Größer als",
  "ag-grid.greaterThanOrEqual": "Größer/Gleich",
  "ag-grid.group": "Gruppe",
  "ag-grid.groupBy": "Gruppieren nach",
  "ag-grid.groupedAreaTooltip": "Bereichsgruppe",
  "ag-grid.groupedBar": "Gruppierte Balken",
  "ag-grid.groupedBarTooltip": "Balkengruppe",
  "ag-grid.groupedColumn": "Gruppierte Spalte",
  "ag-grid.groupedColumnTooltip": "Gruppiert",
  "ag-grid.groups": "Zeilengruppe",
  "ag-grid.histogramBinCount": "Histogram Fülltrichter Summe",
  "ag-grid.histogramChart": "Histogram",
  "ag-grid.histogramGroup": "Histogramgruppe",
  "ag-grid.histogramTooltip": "Histogram",
  "ag-grid.inRange": "Zwischen",
  "ag-grid.inRangeEnd": "Bis",
  "ag-grid.inRangeStart": "Von",
  "ag-grid.italic": "Kursiv",
  "ag-grid.itemPaddingX": "Element Füllung X",
  "ag-grid.itemPaddingY": "Element Füllung Y",
  "ag-grid.labels": "Labels",
  "ag-grid.last": "Letzte",
  "ag-grid.left": "Links",
  "ag-grid.legend": "Legende",
  "ag-grid.length": "Länge",
  "ag-grid.lessThan": "Kleiner als",
  "ag-grid.lessThanOrEqual": "Kleiner/Gleich",
  "ag-grid.line": "Linie",
  "ag-grid.lineGroup": "Liniengruppe",
  "ag-grid.lineTooltip": "Linie",
  "ag-grid.lineWidth": "Breite der Linie",
  "ag-grid.loadingOoo": "Laden...",
  "ag-grid.markerPadding": "Marker Füllung",
  "ag-grid.markers": "Markers",
  "ag-grid.markerSize": "Marker Größe",
  "ag-grid.markerStroke": "Marker Strich",
  "ag-grid.max": "Maximum",
  "ag-grid.maxSize": "Maximule Größe",
  "ag-grid.min": "Minimum",
  "ag-grid.minSize": "Minimalste Größe",
  "ag-grid.more": "Mehr",
  "ag-grid.next": "Nächste",
  "ag-grid.noDataToChart": "Keine Daten verfügbar um dargestellt zu werden.",
  "ag-grid.none": "Keins",
  "ag-grid.noPin": "Nich anheften",
  "ag-grid.normal": "Normal",
  "ag-grid.normalizedArea": "Bereich normalisiert",
  "ag-grid.normalizedAreaTooltip": "Bereich normalisiert",
  "ag-grid.normalizedBar": "Balken normalisiert",
  "ag-grid.normalizedBarTooltip": "Balken normalisiert",
  "ag-grid.normalizedColumn": "Stappelung normalisiert",
  "ag-grid.normalizedColumnTooltip": "Stappelung normalisiert",
  "ag-grid.noRowsToShow": "Keine Zeilen",
  "ag-grid.notContains": "Enthält nicht",
  "ag-grid.notEqual": "Nicht gleich",
  "ag-grid.number": "Nummer",
  "ag-grid.of": "von",
  "ag-grid.offset": "Abstand",
  "ag-grid.offsets": "Abstände",
  "ag-grid.orCondition": "ODER",
  "ag-grid.padding": "Füllung",
  "ag-grid.page": "Seite",
  "ag-grid.paired": "Gepaarter Mode",
  "ag-grid.paste": "Einfügen",
  "ag-grid.pie": "Kuchen",
  "ag-grid.pieChart": "Kuchen Diagramm",
  "ag-grid.pieGroup": "Kuchengruppe",
  "ag-grid.pieTooltip": "Kuchen",
  "ag-grid.pinColumn": "Spalte anheften",
  "ag-grid.pinLeft": "Links anheften",
  "ag-grid.pinRight": "Rechts anheften",
  "ag-grid.pivotChart": "Pivot Diagramm",
  "ag-grid.pivotChartAndPivotMode": "Pivot Chart & Pivot Mode",
  "ag-grid.pivotChartRequiresPivotMode": "Pivot Chart benötigt den Pivot Mode um aktiv zu sein.",
  "ag-grid.pivotChartTitle": "Pivot Chart",
  "ag-grid.pivotColumnsEmptyMessage": "Um die Spaltennamen zu setzen hier her ziehen ",
  "ag-grid.pivotMode": "Pivot-Mode",
  "ag-grid.pivots": "Spaltennamen",
  "ag-grid.position": "Position",
  "ag-grid.predefined": "Vordefiniert",
  "ag-grid.previous": "Vorige",
  "ag-grid.rangeChartTitle": "Bereichs Chart",
  "ag-grid.rangeEnd": "Bis",
  "ag-grid.rangeStart": "Von",
  "ag-grid.resetColumns": "Spalte zurücksetzen",
  "ag-grid.resetFilter": "Filter zurücksetzen",
  "ag-grid.right": "Rechts",
  "ag-grid.rowGroupColumns": "Pivot Spalten",
  "ag-grid.rowGroupColumnsEmptyMessage": "Um die Zeilengruppe zu setzen hier her ziehen",
  "ag-grid.scatter": "Verteiler",
  "ag-grid.scatterGroup": "Verteilergruppe",
  "ag-grid.scatterTooltip": "Gestappelt",
  "ag-grid.searchOoo": "Suchen...",
  "ag-grid.selectAll": "Alle auswählen",
  "ag-grid.selectedRows": "Ausgewählt",
  "ag-grid.series": "Serien",
  "ag-grid.settings": "Einstellungen",
  "ag-grid.shadow": "Schatten",
  "ag-grid.size": "Größe",
  "ag-grid.stackedArea": "Gestappelter Bereich",
  "ag-grid.stackedAreaTooltip": "Gestappelter Bereich",
  "ag-grid.stackedBar": "Gestappelte Balken",
  "ag-grid.stackedBarTooltip": "Verteilergruppe",
  "ag-grid.stackedColumn": "Gestappelte Spalte",
  "ag-grid.stackedColumnTooltip": "Gestappelt",
  "ag-grid.startsWith": "Beginnt mit",
  "ag-grid.strokeOpacity": "Deckkraft Linien",
  "ag-grid.strokeWidth": "Strich Breite",
  "ag-grid.sum": "Summe",
  "ag-grid.thickness": "Dicke",
  "ag-grid.ticks": "Kreuze",
  "ag-grid.time": "Zeit",
  "ag-grid.title": "Titel",
  "ag-grid.to": "bis",
  "ag-grid.toolPanel": "Werkzeug Panel",
  "ag-grid.toolPanelButton": "Werkzeug Panel",
  "ag-grid.tooltips": "Tooltips",
  "ag-grid.top": "Oben",
  "ag-grid.totalAndFilteredRows": "Alle und Gefilterte Zeilen",
  "ag-grid.totalRows": "Alle Zeilen",
  "ag-grid.ungroupBy": "Gruppieren aufheben",
  "ag-grid.valueAggregation": "Wert Aggregation",
  "ag-grid.valueColumns": "Wertspalten",
  "ag-grid.valueColumnsEmptyMessage": "Um die Spalten zu aggregieren hier her ziehen",
  "ag-grid.values": "Werte",
  "ag-grid.width": "Breite",
  "ag-grid.xOffset": "X Abstand",
  "ag-grid.xRotation": "X Rotation",
  "ag-grid.xType": "X Type",
  "ag-grid.xyChart": "X Y Diagramm",
  "ag-grid.xyValues": "X Y Werte",
  "ag-grid.yOffset": "Y Abstand",
  "ag-grid.yRotation": "Y Rotation",
  "APP_TITLE": "TuR Recourse Cockpit",
  "APPROVAL_BOOKING_FAILED": "Buchung {{0}} konnte nicht freigegeben werden.",
  "APPROVAL_BOOKING_SUCCESSFUL": "Buchung {{0}} wurde erfolgreich freigegeben.",
  "APPROVAL_PROCESS_CONFIRMDIALOG_MESSAGE": "Buchung wird gespeichert und zur Freigabe bereitgestellt. Möchten Sie den Freigabeprozess wirklich starten?'",
  "APPROVAL_PROCESS_CONFIRMDIALOG_TITLE": "Freigabeprozess starten",
  "APPROVAL_PROCESS_FAILED_MESSAGE": "Freigabeprozess konnte nicht gespeichert werden",
  "APPROVAL_PROCESS_FAILED_TITLE": "Freigabeprozess fehlgeschlagen",
  "APPROVAL_PROCESS_STARTED_SUCCESSFUL": "Buchung wird gespeichert und zur Freigabe bereitgestellt.",
  "APPROVAL_PROCESS_TITLE": "Freigabeprozess gestartet",
  "APPROVAL_TAB": "Freigaben",
  "APPROVAL_TAB_TITLE": "Übersicht",
  "APPROVAL_TABLE_AMOUNT": "Netto.",
  "APPROVAL_TABLE_APPROVE_BUTTON": "Freigeben",
  "APPROVAL_TABLE_BOOKING_ID": "Nr.",
  "APPROVAL_TABLE_BOOKING_TYPE": "Buch.art",
  "APPROVAL_TABLE_CREATE_DATE": "Ang.am",
  "APPROVAL_TABLE_CREATOR": "Bearb.",
  "APPROVAL_TABLE_DEBITOR_ID": "Deb.-Nr.",
  "APPROVAL_TABLE_DETAILS_BUTTON": "Details",
  "APPROVAL_TABLE_INVOICE_REASON": "Fkta.gr.",
  "APPROVAL_TABLE_RECOURSE_TYPE": "Regr.art",
  "APPROVAL_TABLE_REJECT_BUTTON": "Ablehnung",
  "APPROVAL_TABLE_SUPPLIER": "Kred.",
  "APPROVAL_TABLE_SUPPLIER_ID": "Kred.Nr.",
  "APPROVAL_TABLE_TOOLTIP_AMOUNT": "Nettowert",
  "APPROVAL_TABLE_TOOLTIP_BOOKING_ID": "Beleg-Nr.",
  "APPROVAL_TABLE_TOOLTIP_BOOKING_TYPE": "Buchungsart",
  "APPROVAL_TABLE_TOOLTIP_CREATE_DATE": "Angelegt am",
  "APPROVAL_TABLE_TOOLTIP_CREATOR": "Bearbeiter",
  "APPROVAL_TABLE_TOOLTIP_DEBITOR_ID": "Debitor-Nr.",
  "APPROVAL_TABLE_TOOLTIP_INVOICE_REASON": "Fakturagrund",
  "APPROVAL_TABLE_TOOLTIP_RECOURSE_TYPE": "Regressart",
  "APPROVAL_TABLE_TOOLTIP_SUPPLIER": "Kreditor",
  "APPROVAL_TABLE_TOOLTIP_SUPPLIER_ID": "Kreditor Nr.",
  "APPROVAL_WORKFLOW_BOOKING_FAILED": "Freigabeprozess für Buchung/en {{0}} konnte nicht gestartet werden.",
  "APPROVAL_WORKFLOW_BOOKING_SUCCESSFUL": "Buchung/en {{0}} wurde/n gespeichert und zur Freigabe bereitgestellt.",
  "APPROVE_AUTOMATED_AFTERSALES_BOOKINGS": "Alle autom. Buchungen freigeben",
  "APPROVE_AUTOMATED_BOOKINGS_DIALOG_MESSAGE": "Möchten Sie wirklich {{0}} automatische {{1}} Buchungen freigeben?",
  "APPROVE_AUTOMATED_BOOKINGS_FAILED_MESSAGE": "{{0}} Buchungen konnten nicht freigegeben werden.",
  "APPROVE_AUTOMATED_BOOKINGS_SUCCESS_MESSAGE": "{{0}} Buchungen wurden freigegeben.",
  "APPROVE_AUTOMATED_RECOURSE_BOOKINGS": "Belastungslauf freigeben",
  "APPROVE_BOOKING_FAILED_MESSAGE": "Freigabe fehlgeschlagen: Die Buchung {{0}} konnte nicht freigegeben werden.",
  "APPROVE_BOOKING_FAILED_TITLE": "Freigabe fehlgeschlagen",
  "APPROVE_BOOKING_MESSAGE": "Buchung freigegeben: Buchung {{0}} wurde erfolgreich freigeben.",
  "APPROVE_BOOKING_TITLE": "Buchung freigegeben",
  "APPROVE_DIALOG_MESSAGE": "Möchten Sie die Buchung wirklich freigeben?",
  "APPROVE_DIALOG_TITLE": "Buchung wirklich freigeben?",
  "APPROVED": "Freigegeben",
  "ATTACHMENT_CAN_NOT_BE_SAVED": "Anhang kann nicht entfernt werden",
  "ATTACHMENT_CAN_NOT_BE_SAVED_MESSAGE": "Aufgrund des aktuellen Aktionsstatus kann dieser Anhang nicht entfernt werden.",
  "ATTACHMENTS_CREATOR": "Ersteller",
  "ATTACHMENTS_DATE": "Datum",
  "ATTACHMENTS_FILE_NAME": "Dateiname",
  "ATTACHMENTS_RECEIVER": "Empfänger",
  "AUTHENTICITY_AUDIT_REPORT_ADDITIONAL_COSTS_FAILED": "Die Verifizierung der Zusatzkosten für den Regress-Audit-Report {{0}} ist fehlgeschlagen, bitte wenden Sie sich umgehend an Ihren Systemadministrator.",
  "AUTHENTICITY_AUDIT_REPORT_ADDITIONAL_COSTS_FAILED_TITLE": "Verifizierung der Audit-Report-Zusatzkosten fehlgeschlagen",
  "AUTHENTICITY_AUDIT_REPORT_FAILED": "Die Verifizierung des Regress-Audit-Reports {{0}} ist fehlgeschlagen, bitte wenden Sie sich umgehend an Ihren Systemadministrator.",
  "AUTHENTICITY_AUDIT_REPORT_FAILED_TITLE": "Verifizierung des Regress-Audit-Berichts fehlgeschlagen",
  "AUTHENTICITY_ERROR_COST_RATE_FAILED": "Verifizierung des Fehlerkostensatzen {{0}} fehlgeschlagen",
  "AUTHENTICITY_ERROR_COST_RATE_FAILED_LONG": "Die Verifizierung der Fehlerkostensätze für den Regress-Audit-Report {{0}} ist fehlgeschlagen, bitte wenden Sie sich umgehend an Ihren Systemadministrator.",
  "AUTHENTICITY_ERROR_COST_RATE_FAILED_TITLE": "Verifizierung der Fehlerkostensätze fehlgeschlagen",
  "AUTHENTICITY_FILE_CHECKSUM_FAILED_TITLE": "Verifizierung der Prüfsumme von der Datei fehlgeschlagen",
  "AUTHENTICITY_FILE_FAILED_TITLE": "Verifizierung der Datei fehlgeschlagen",
  "AUTHENTICITY_RECOURSE_BOOKING_ATTACHMENTS_FAILED_TITLE": "Verifizierung der Anhänge fehlgeschlagen",
  "AUTHENTICITY_RECOURSE_BOOKING_FAILED_TITLE": "Verifizierung der Buchung fehlgeschlagen",
  "BLOCKED": "Geblockt",
  "BOOKED": "Gebucht",
  "BOOKING_APPROVAL_HISTORY": "Historie",
  "BOOKING_APPROVAL_HISTORY_ACTION": "Aktion",
  "BOOKING_APPROVAL_HISTORY_DATE": "Datum",
  "BOOKING_APPROVAL_HISTORY_EDITOR": "Bearbeiter",
  "BOOKING_APPROVAL_HISTORY_NO_VALUES": "Keine Daten vorhanden",
  "BOOKING_APPROVAL_HISTORY_STEP": "Schritt",
  "BOOKING_APPROVAL_HISTORY_TIME": "Uhrzeit",
  "BOOKING_APPROVAL_REQUESTED": "Buchungsfreigabe angefordert",
  "BOOKING_BLOCKED": "Buchung blockiert",
  "BOOKING_BLOCKED_ACTION": "Lieferant ungültig - Buchung geblockt",
  "BOOKING_BOOKED_ACTION": "Buchung an SAP übertragen",
  "BOOKING_CANCELLED": "Buchung storniert",
  "BOOKING_CANCELLED_ACTION": "Buchung storniert",
  "BOOKING_CREATED": "Buchung erstellt",
  "BOOKING_CREATED_ACTION": "Buchung angelegt",
  "BOOKING_DETAILS": "Details",
  "BOOKING_DETAILS_ADDRESS": "Anschrift",
  "BOOKING_DETAILS_APPROVE_BOOKING": "Buchung freigeben",
  "BOOKING_DETAILS_ATTACHMENTS": "Anhänge",
  "BOOKING_DETAILS_ATTACHMENTS_CREATOR": "Ersteller",
  "BOOKING_DETAILS_ATTACHMENTS_DATE": "Datum",
  "BOOKING_DETAILS_ATTACHMENTS_FILE_NAME": "Dateiname",
  "BOOKING_DETAILS_ATTACHMENTS_RECEIVER": "Empfänger",
  "BOOKING_DETAILS_BOOKING_JUSTIFICATION_COMMENT": "Begründung für die Buchung",
  "BOOKING_DETAILS_BOOKING_TYPE": "Buchungsart",
  "BOOKING_DETAILS_CITY": "Ort",
  "BOOKING_DETAILS_COMMENT_CHARACTER_LEFT": "Verbleibende Zeichen:",
  "BOOKING_DETAILS_CREATE_CORRECTION_BOOKING": "Korrekturbuchung erstellen",
  "BOOKING_DETAILS_CREATE_MANUAL_BOOKING": "Manuelle Buchung erstellen",
  "BOOKING_DETAILS_CREATED_ON": "Angelegt am",
  "BOOKING_DETAILS_CREATOR": "Ersteller",
  "BOOKING_DETAILS_CURRENCY": "Währung",
  "BOOKING_DETAILS_DEBITOR": "Debitor",
  "BOOKING_DETAILS_DIALOG_FAILED_MESSAGE": "Bitte kontaktieren Sie ihren Key User. Der Beleg der Buchung {{0}} muss manuell im SAP gelöscht werden.",
  "BOOKING_DETAILS_DIALOG_FAILED_TITLE": "Achtung: Buchung fehlgeschlagen",
  "BOOKING_DETAILS_DUE_DATE": "Fälligkeit",
  "BOOKING_DETAILS_EXTERNAL_RECEIVER": "Empfänger extern",
  "BOOKING_DETAILS_GENERAL_INFO": "Allgemeine Daten",
  "BOOKING_DETAILS_ID": "Beleg-Nr.",
  "BOOKING_DETAILS_INVOICE_REASON": "Fakturagrund",
  "BOOKING_DETAILS_NAME": "Name",
  "BOOKING_DETAILS_NET_AMOUNT": "Nettowert",
  "BOOKING_DETAILS_NO_ATTACHMENTS_MESSAGE": "Keine Anhänge vorhanden",
  "BOOKING_DETAILS_PARTIAL_PAYMENT": "Teilzahlung",
  "BOOKING_DETAILS_POST_OFFICE_BOX": "Postfach",
  "BOOKING_DETAILS_POSTAL_CODE": "Postleitzahl",
  "BOOKING_DETAILS_POSTAL_CODE_PO_BOX": "Postleitzahl Postfach",
  "BOOKING_DETAILS_RECOURSE_TYPE": "Regressart",
  "BOOKING_DETAILS_REJECT_BOOKING": "Buchung ablehnen",
  "BOOKING_DETAILS_REPROCESS": "Erneut verarbeiten",
  "BOOKING_DETAILS_REVENUE_ORDER_NUMBER": "Erlösauftragsnummer",
  "BOOKING_DETAILS_STATE": "Land",
  "BOOKING_DETAILS_STATUS": "Status",
  "BOOKING_DETAILS_STREET_ADDRESS": "Straße, Haus-Nr.",
  "BOOKING_DETAILS_SUPPLIER": "Kreditor",
  "BOOKING_DETAILS_TAB_TITLE": "Details",
  "BOOKING_DETAILS_TOTAL_CALCULATED_AMOUNT": "Gesamtnettowert:",
  "BOOKING_FAILED_ACTION": "Übertragung an SAP fehlgeschlagen",
  "BOOKING_IN_INTERNAL_APPROVAL": "Buchung befindet sich im internen Freigabeprozess",
  "BOOKING_INTERNAL_APPROVED": "Buchung intern freigegeben",
  "BOOKING_IS_BOOKED": "Buchung eingebucht",
  "BOOKING_IS_PRINTED": "Buchung gedruckt",
  "booleanToYesNo.false": "nein",
  "booleanToYesNo.true": "ja",
  "BUILD_DATE": "Erstelldatum",
  "BUILD_VERSION": "Version",
  "CAMPAIGN": "Aktion",
  "CAMPAIGN_DETAILS": "Details",
  "CAMPAIGN_DETAILS_GENERAL_INFO": "Allgemeine Daten",
  "CAMPAING_DETAILS_MESSAGE_2": "Vorbedingung für neuen Status nicht erfüllt. Status kann nicht gesetzt werden. Veröffentlichungsdatum und Pflichtfelder müssen ausgefüllt sein.",
  "CAMPAING_DETAILS_MESSAGE_3": "Vorbedingung für neuen Status nicht erfüllt. Status kann nicht gesetzt werden. Mangelrüge Datum und ein Anhang müssen vorhanden sein.",
  "CAMPAING_DETAILS_MESSAGE_4": "Vorbedingung für neuen Status nicht erfüllt. Status kann nicht gesetzt werden. Regressforderungsdatum und ein Anhang müssen vorhanden sein.",
  "CAMPAING_DETAILS_MESSAGE_5": "Vorbedingung für neuen Status nicht erfüllt. Status kann nicht gesetzt werden. Verhandlungsdatum und ein Anhang müssen vorhanden sein.",
  "CAMPAING_DETAILS_MESSAGE_6": "Vorbedingung für neuen Status nicht erfüllt. Status kann nicht gesetzt werden. Mindestens eine Buchung zur Aktion muss vorhanden sein.",
  "CANCEL": "Abbrechen",
  "CANCEL_BOOKING_BUTTON": "Buchung stornieren",
  "CANCEL_BOOKING_FAILED": "Buchung {{0}} konnte nicht storniert werden.",
  "CANCEL_BOOKING_MESSAGE": "Aktuelle Buchung wird storniert und geänderte Daten nicht gespeichert. Wollen Sie wirklich fortfahren?",
  "CANCEL_BOOKING_SUCCESSFUL": "Buchung storniert: Buchung {{0}} wurde erfolgreich storniert.",
  "CANCEL_BOOKING_TITLE": "Buchung stornieren",
  "CANCELLED": "Storniert",
  "CANCELLED_STOPPED_CHANGED": "Gecancelt/gestoppt/gewandelt",
  "CENTRAL_BOOKING_BLOCK": "Debitor zum Buchen gesperrt",
  "CENTRAL_INVOICE_BLOCK": "Debitor für Faktura gesperrt",
  "CENTRAL_ORDER_BLOCK": "Debitor für Aufträge gesperrt",
  "CHANGE_OF_STATE": "Statusänderung",
  "CHOOSE_ONE": "Auswählen",
  "COMMENT_INVOICE_REASON": "Fakturagrund eingeben",
  "COMPANY_CODE_BLOCK": "Debitor zum Buchen im Buchungskreis gesperrt",
  "COMPLAINT": "Mangelrüge",
  "COMPLAINT_DATE_OF_DISPATCH": "Mangelrüge versendet",
  "COMPLETED": "Abgeschlossen",
  "COMPLETELY_BOOKED": "Alles gebucht",
  "COMPONENT_MARKING": "Bauteilkennzeichnung",
  "CONFIRM": "Bestätigen",
  "CREATOR_APPROVED_ACTION": "Freigabe Ersteller / Zur Freigabe vorgelegt",
  "CREDIT": "Gutschrift",
  "CREDIT_BOOKING_APPROVED": "Gutschrift freigegeben",
  "CREDIT_BOOKING_REJECTED": "Gutschrift abgelehnt",
  "dateFormat": "dd.MM.yyyy",
  "DEBIT": "Rechnung",
  "DEFAULT_VIEW": "Standardansicht",
  "DELETE_ADDITIONAL_COST_FAILED": "Der Zusatzkosten {{0}} für Prüfbericht {{1}} konnte nicht abgelehnt werden.",
  "DELETE_ADDITIONAL_COST_MESSAGE": "Möchten Sie folgende Zusatzkosten wirklich löschen? <br><br>Kategorie: {{0}} <br>Beschreibung: {{1}} <br>Zusatzkosten [€]: {{2}}",
  "DELETE_ADDITIONAL_COST_SUCCESSFUL": "Der Zusatzkosten {{0}} für Prüfbericht {{1}} wurde erfolgreich gelöscht.",
  "DELETE_ADDITIONAL_COST_TITLE": "Zusatzkosten löschen",
  "DELETE_ATTACHMENT_FAILED": "Anhang {{0}} konnte nicht gelöscht werden.",
  "DELETE_ATTACHMENT_MESSAGE": "Möchten Sie den Anhang wirklich löschen?",
  "DELETE_ATTACHMENT_SUCCESSFUL": "Anhang {{0}} wurde erfolgreich gelöscht.",
  "DELETE_ATTACHMENT_TITLE": "Anhang löschen",
  "DELETE_FILE_FAILED_TITLE": "Löschen fehlgeschlagen",
  "DOWNLOAD_ATTACHMENT_FAILED": "Anhang {{0}} konnte nicht heruntergeladen werden.",
  "DOWNLOAD_FAILED_TITLE": "Download fehlgeschlagen",
  "DUE_DATE_REVENUES": "Erlöse eingestellt",
  "DUPLICATE_CAMPAIGN": "Aktion duplizieren",
  "DUPLICATE_CAMPAIGN_ERROR_MESSAGE": "Aktion konnte nicht dupliziert werden.",
  "DUPLICATE_CAMPAIGN_ERROR_TITLE": "Fehler beim Aktion {{0}} duplizieren.",
  "DUPLICATE_CAMPAIGN_OPERATION_ID": "Vorgangsnr.",
  "DUPLICATE_CAMPAIGN_SUCCESS_MESSAGE": "Aktion wurde erfolgreich dupliziert.",
  "DUPLICATE_CAMPAIGN_SUCCESS_TITLE": "Aktion {{0}} dupliziert",
  "EDIT_BOOKING_TAB_TITLE": "Bearbeiten",
  "ERROR_CODE_0000": "Ein Netzwerk Fehler ist aufgetreten",
  "ERROR_CODE_1000": "Unbekannte Sprache",
  "ERROR_CODE_2000": "Nachricht fehlt",
  "ERROR_CODE_2001": "Log-level fehlt",
  "ERROR_CODE_2002": "Datum fehlt",
  "ERROR_CODE_3000": "Benutzer hat keine Berechtigung für diese Aktion",
  "ERROR_CODE_3001": "Benutzer hat keine Lese Berechtigung",
  "ERROR_CODE_3002": "Benutzer hat keine Freigabe Berechtigung",
  "ERROR_CODE_3003": "Benutzer hat keine Buchungsberechtigung",
  "ERROR_CODE_3004": "Benutzer hat keine Aktionsregress Prozess Berechtigung",
  "ERROR_CODE_4000": "Validierung fehlgeschlagen für: {{0}}",
  "ERROR_CODE_4001": "Nebenläufigkeitsfehler",
  "ERROR_CODE_5000": "Buchung mit der id={{0}} konnte nicht gefunden werden",
  "ERROR_CODE_6001": "Zulieferer mit der id={{0}} konnte nicht gefunden werden",
  "ERROR_CODE_7000": "Originaler Dateiname Argument ist null",
  "ERROR_CODE_7001": "Leere Datei wurde nicht gespeichert",
  "ERROR_CODE_7002": "Der Anhang hat einen ungültigen Dateinamen.",
  "ERROR_CODE_7003": "Datei konnte nicht gelesen werden",
  "ERROR_CODE_7004": "Datei wurde nicht gefunden",
  "ERROR_CODE_7005": "Herunterladen der Datei fehlgeschlagen",
  "ERROR_CODE_7006": "Die Prüfsumme der Datei konnte nicht generiert werden",
  "ERROR_CODE_7007": "Datei konnte nicht gespeichert werden da keine Referenz zu einer Buchung vorliegt",
  "ERROR_CODE_7008": "Löschen der Datei fehlgeschlagen",
  "ERROR_CODE_7100": "Hochladen der Datei fehlgeschlagen",
  "ERROR_CODE_8000": "Die Verifizierung ist fehlgeschlagen",
  "ERROR_CODE_8002": "Die Verifizierung der Prüfsumme von der Datei {{0}} - {{1}} ist fehlgeschlagen, bitte wenden Sie sich unverzüglich an ihren Systemadministrator",
  "ERROR_CODE_8003": "Die Verifizierung des Anhangs {{0}} ist fehlgeschlagen, Anhang {{0}} - {{1}} wurde manipuliert, bitte wenden Sie sich unverzüglich an ihren Systemadministrator",
  "ERROR_CODE_8004": "Buchung {{0}} wurde manipuliert, bitte wenden Sie sich unverzüglich an ihren Systemadministrator",
  "ERROR_CODE_8005": "Anhänge der Buchung {{0}} wurden manipuliert, bitte wenden Sie sich unverzüglich an ihren Systemadministrator",
  "ERROR_COST_RATE_CLASS_A": "A",
  "ERROR_COST_RATE_CLASS_B": "B",
  "EXCEL_EXPORT": "Excel export",
  "EXCEL_EXPORT_AFTER_SALES_OVERVIEW": "After Sales - Prüfberichte Übersicht",
  "EXCEL_EXPORT_APPROVAL_OVERVIEW": "Freigabe - Freigabeübersicht",
  "EXCEL_EXPORT_BOOKING_OVERVIEW": "Regulierungsbedarfe - Bedarfsübersicht",
  "EXCEL_EXPORT_CAMPAIGN_RECOURSE_OVERVIEW": "Aktionsregress - Aktionsregressübersicht",
  "EXCEL_EXPORT_CONFIDENTIAL": "Vertraulich",
  "EXCEL_EXPORT_CONFIDENTIAL_LEVEL": "Vertraulichkeitsstufe:",
  "EXCEL_EXPORT_DATE": "Datum:",
  "EXCEL_EXPORT_ERROR_CONTENT": "Bei der Erstellung der Excel-Datei ist ein Fehler aufgetreten.",
  "EXCEL_EXPORT_ERROR_TITLE": "Excel Export fehlgeschlagen",
  "EXPLICIT_PAYMENT_TARGET": "Explizites Zahlungsziel festlegen",
  "EXTERNAL": "Extern",
  "FAILED": "Buchung Fehlgeschlagen",
  "FIELD_MASTER_DATA_TAB": "Feldstammdaten",
  "FILTER_SEARCH_CRITERIA": "Filter Suchriterien",
  "FORM_CONTAINS_UNSAVED_DATA_MESSAGE": "Änderungen werden nicht gespeichert, trotzdem fortfahren?",
  "FORM_CONTAINS_UNSAVED_DATA_TITLE": "Ungespeicherte Änderungen",
  "GENERAL_DATA": "Allgemeine Daten",
  "IN_APPROVAL": "In Freigabe",
  "IN_NEGOTIATION": "In Verhandlung",
  "IN_PROGRESS": "In Bearbeitung",
  "INSOLVENCY_FLAG": "Debitor ist insolvent",
  "INTERNAL": "Intern",
  "INTERNAL_APPROVED_ACTION": "Interne Genehmigung erteilt",
  "INTERNAL_FAULT": "Internes Verschulden",
  "INTERNAL_REJECTED_ACTION": "Interne Genehmigung abgelehnt",
  "INVOICE_REASON_TEXT_CORRECTION_BOOKING": "Gutschrift zu:",
  "LBL_ALL": "Alle",
  "LBL_ALL_WITH": "Alle (gefiltert)",
  "NEGOTIATED": "Verhandlung geführt",
  "NEGOTIATION": "Verhandlung",
  "NETWORK_ERROR_TITLE": "Netzwerk Fehler",
  "NEW_CAMPAIGN": "Neue Aktion",
  "NO": "Nein",
  "NO_CUSTOMER_AVAILABLE": "Debitor nicht vorhanden",
  "NO_REFERENCED_BOOKINGS_AVAILABLE": "Keine Referenzbuchungen vorhanden",
  "NO_SUPPLIER_FAULT": "Kein Lieferantenverursachtes Problem",
  "noDataFound": "Keine Daten vorhanden",
  "noMatchingRows": "Keine passenden Zeilen",
  "NOTIFICATION_DELETE_MISC_ERROR_HEADER": "Fehler beim löschen",
  "NOTIFICATION_DELETE_MISC_ERROR_MESSAGE": "Löschen wurde nicht durchgeführt",
  "NOTIFICATION_DELETE_MISC_SUCCESS_HEADER": "Löschen erfolgreich",
  "NOTIFICATION_DELETE_MISC_SUCCESS_MESSAGE": "Löschen wurde erfolgreich durchgeführt",
  "NOTIFICATION_SAVE_ERROR_HEADER": "Fehler beim speichern",
  "NOTIFICATION_SAVE_ERROR_MESSAGE": "Änderungen wurden nicht gespeichert",
  "NOTIFICATION_SAVE_ERROR_MESSAGE_REASON_PERMISSON": "User besitzt keine ausreichenden Berechtigungen",
  "NOTIFICATION_UNEXPECTED_ERROR_HEADER": "Unerwarteter Fehler",
  "NOTIFICATION_UNEXPECTED_ERROR_MESSAGE": "Bitte Service kontaktieren",
  "objectCriteria.1": "1 Neuwagengarantie",
  "objectCriteria.2": "2 Ersatzteilgarantie",
  "objectCriteria.5": "5 Lackgarantie",
  "objectCriteria.7": "7 Aktionsgarantie",
  "objectCriteria.8": "8 Ersatzteilgarantie Thekenverkauf",
  "objectCriteria.9": "9 Langzeitgarantie",
  "objectCriteria.E": "E Emissionsgarantie",
  "objectCriteria.G": "G Gebrauchtwagengarantie",
  "objectCriteriaGroup.SERIES": "Serie",
  "objectCriteriaGroup.SPARE_PART": "Ersatzteil",
  "objectCriteriaGroup.WILD_CARD": "*",
  "OK": "OK",
  "OPEN": "Offen",
  "PACKAGE_MARKING": "Verpackungskennzeichnung",
  "PACKAGING_QUALITY": "Verpackungsqualität",
  "partsAgreement.add.btnCancel": "Abbrechen",
  "partsAgreement.add.btnSave": "Speichern",
  "partsAgreement.add.comment": "Kommentar",
  "partsAgreement.add.commentCharacterLeft": "Verbleibende Zeichen:",
  "partsAgreement.add.errorCode15009": "Zu viele Überschneidungen mit bestehenden Datensatz",
  "partsAgreement.add.modelYearFormat": "Format YYYY erwartet!",
  "partsAgreement.add.modelYearNotAllowed": "Von bis ungültig!",
  "partsAgreement.add.orderTypeValidation": "Länge zwischen 3 - 6 Zeichen!",
  "partsAgreement.add.partNumberValidation": "Länge zwischen 9 - 11 Zeichen!",
  "partsAgreement.add.supplierCity": "Ort",
  "partsAgreement.add.tab": "Neue Teilevereinbarung",
  "partsAgreement.add.technicalFactorValidation": "Nummer zwischen 0 - 100!",
  "partsAgreement.add.validationCurrentDate": "Wert muss größer/gleich aktuelles Datum sein!",
  "partsAgreement.add.validatorInvalidCharacters": "Ungültiges Zeichen",
  "partsAgreement.comment": "Kommentar",
  "partsAgreement.commentInvalidCharacters": "Die Zeichen { } sind nicht erlaubt. < > sind nur um E-Mail-Adressen erlaubt.",
  "partsAgreement.edit": "Teilevereinbarung bearbeiten",
  "partsAgreement.httpCode200": "Element erfolgreich gespeichert. Id: {{0}} ",
  "partsAgreement.id": "ID",
  "partsAgreement.modelYearFrom": "Modelljahr (von)",
  "partsAgreement.modelYearFromShort": "MJ (von)",
  "partsAgreement.modelYearTo": "Modelljahr (bis)",
  "partsAgreement.modelYearToShort": "MJ (bis)",
  "partsAgreement.orderType": "Bestelltyp",
  "partsAgreement.orderTypeShort": "B-Typ",
  "partsAgreement.productionDateFrom": "Produktionsdatum (von)",
  "partsAgreement.productionDateFromShort": "ZP8 (von)",
  "partsAgreement.productionDateTo": "Produktionsdatum (bis)",
  "partsAgreement.productionDateToShort": "ZP8 (bis)",
  "partsAgreement.sparePartNumber": "Teilenummer eingebaut",
  "partsAgreement.sparePartNumberShort": "TNr. eingeb.",
  "partsAgreement.supplierName": "Lieferantenname",
  "partsAgreement.supplierNameShort": "L-Name",
  "partsAgreement.supplierNumber": "Lieferantennummer",
  "partsAgreement.supplierNumberShort": "Lieferant",
  "partsAgreement.saveError.content": "Fehler beim Speichern der Teilevereinbarung",
  "partsAgreement.saveError.title": "Fehler",
  "partsAgreement.saveSuccess.content": "Teilevereinbarung erfolgreich gespeichert",
  "partsAgreement.saveSuccess.title": "Erfolg",
  "partsAgreement.tab": "Teilevereinbarung",
  "partsAgreement.technicalFactor": "Technischer Faktor [%]",
  "partsAgreement.technicalFactorShort": "TF",
  "partsAgreement.validityDateFrom": "Gültigkeitszeitraum (von)",
  "partsAgreement.validityDateFromShort": " Gültig (von)",
  "partsAgreement.validityDateTo": "Gültigkeitszeitraum (bis)",
  "partsAgreement.validityDateToShort": " Gültig bis",
  "partsAgreementsOverview.btnAdd": "Teilevereinbarung hinzufügen",
  "PREPARE_DATA": "Daten aufbereiten",
  "PUBLISH_DATE": "Aktion veröffentlicht",
  "RAD": "Entwicklung",
  "recourceCriteria.add": "Regresskriterien hinzufügen",
  "recourceCriteria.saveError.content": "Fehler beim Speichern der Regresskriterien",
  "recourceCriteria.saveError.overlap": "Ein Regresskriterium mit identischer Teilenummer, Lieferantennummer, Händlernummer, Objektkriteriengruppe und überschneidendem Gültigkeitszeitraum existiert bereits.",
  "recourceCriteria.saveError.title": "Fehler",
  "recourceCriteria.saveSuccess.content": "Regresskriterien gespeichert",
  "recourceCriteria.saveSuccess.title": "Erfolg",
  "RECOURSE": "GuK Regress",
  "RECOURSE_AUDIT_REPORT_STATE_CANCELLED": "Storniert",
  "RECOURSE_AUDIT_REPORT_STATE_CLOSED": "Geschlossen",
  "RECOURSE_AUDIT_REPORT_STATE_OPEN": "Offen",
  "RECOURSE_BOOKING_TAB": "Buchungen",
  "RECOURSE_BOOKING_TAB_TITLE": "Übersicht",
  "RECOURSE_BOOKING_TABLE_ANGELEGT_AM": "Ang. am",
  "RECOURSE_BOOKING_TABLE_BELEG_NR": "Nr.",
  "RECOURSE_BOOKING_TABLE_BOOKING_TYPE": "Buch. art",
  "RECOURSE_BOOKING_TABLE_CREATION_TYPE": "Erst. art",
  "RECOURSE_BOOKING_TABLE_DEBITOR_NR": "Deb.-Nr.",
  "RECOURSE_BOOKING_TABLE_DUE_DATE": "Fälligkeits- Buchungsdatum",
  "RECOURSE_BOOKING_TABLE_ERSTELLER": "Bearb.",
  "RECOURSE_BOOKING_TABLE_FAKTURAGRUND": "Fkta. gr.",
  "RECOURSE_BOOKING_TABLE_LIEFERANT": "Kred.",
  "RECOURSE_BOOKING_TABLE_LIEFERANT_NR": "Kred.Nr.",
  "RECOURSE_BOOKING_TABLE_NETTOWERT": "Netto.",
  "RECOURSE_BOOKING_TABLE_RECOURSE_TYPE": "Regr. art",
  "RECOURSE_BOOKING_TABLE_REVENUE_ORDER_NUMBER": "Erl.Auft.Nr.",
  "RECOURSE_BOOKING_TABLE_STATUS": "Status",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_ANGELEGT_AM": "Angelegt am",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_BELEG_NR": "Beleg-Nr.",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_BOOKING_TYPE": "Buchungsart",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_CREATION_TYPE": "Erstellart",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_DEBITOR_NR": "Debitor-Nr.",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_DUE_DATE": "Fäll.-/Buch.Datum",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_ERSTELLER": "Bearbeiter",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_FAKTURAGRUND": "Fakturagrund",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_LIEFERANT": "Kreditor",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_LIEFERANT_NR": "Kreditor Nr.",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_NETTOWERT": "Nettowert",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_RECOURSE_TYPE": "Regressart",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_REVENUE_ORDER_NUMBER": "Erlösauftragsnummer",
  "RECOURSE_BOOKING_TABLE_TOOLTIP_STATUS": "Status",
  "RECOURSE_CAMPAIGN_DETAIL_AFFECTED_MARKETS": "Betroffene Märkte",
  "RECOURSE_CAMPAIGN_DETAIL_AFFECTED_VEHICLES": "Betroffene Fahrzeuge",
  "RECOURSE_CAMPAIGN_DETAIL_ASSIGNEE": "Bearbeiter",
  "RECOURSE_CAMPAIGN_DETAIL_BOOKINGS": "Buchungen",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS": "Prognosekosten(SOLL)[€]",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS_ACTUAL": "Aktionskosten(IST)[€]",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_COSTS_PROGNOSIS": "Aktionskosten(SOLL)(100%)[€]",
  "RECOURSE_CAMPAIGN_DETAIL_CAMPAIGN_RECOURSE_ID": "Aktionsnr.",
  "RECOURSE_CAMPAIGN_DETAIL_CHANGE_DATE": "Änderungsdatum",
  "RECOURSE_CAMPAIGN_DETAIL_COMPLAINT": "Mangelrüge",
  "RECOURSE_CAMPAIGN_DETAIL_COMPLAINT_CHANGE_DATE": "Mangelrüge versendet",
  "RECOURSE_CAMPAIGN_DETAIL_CREATION_DATE": "Erstelldatum",
  "RECOURSE_CAMPAIGN_DETAIL_DIALOG_CAUSE_OF_REJECTION": "Ablehnungsgrund",
  "RECOURSE_CAMPAIGN_DETAIL_DIALOG_INVALID_ASSIGNEE_MESSAGE": "Bearbeiter ungültig. Bitte wählen Sie einen gültigen Bearbeiter.",
  "RECOURSE_CAMPAIGN_DETAIL_DIALOG_INVALID_ASSIGNEE_TITLE": "Bearbeiter ungültig",
  "RECOURSE_CAMPAIGN_DETAIL_EXAMINATION_REGRESS_E_P": "Prüfung Regress E/P",
  "RECOURSE_CAMPAIGN_DETAIL_EXTERNAL_CONTACT": "Ansprechpartner extern",
  "RECOURSE_CAMPAIGN_DETAIL_FKCAMPAIGN_STATE_ID": "Status",
  "RECOURSE_CAMPAIGN_DETAIL_FULFILLMENT_DEGREE": "Erfüllungsgrad[%]",
  "RECOURSE_CAMPAIGN_DETAIL_GENERAL_INFO": "Allgemeine Daten",
  "RECOURSE_CAMPAIGN_DETAIL_INTERNAL_CONTACT": "Ansprechpartner intern",
  "RECOURSE_CAMPAIGN_DETAIL_NAME1": "Kreditor",
  "RECOURSE_CAMPAIGN_DETAIL_NEGOTIATION": "Verhandlung",
  "RECOURSE_CAMPAIGN_DETAIL_NEGOTIATION_CHANGE_DATE": "Verhandlungstermin",
  "RECOURSE_CAMPAIGN_DETAIL_NOTE": "Bemerkung",
  "RECOURSE_CAMPAIGN_DETAIL_OPERATION_ID": "Vorgangsnr.",
  "RECOURSE_CAMPAIGN_DETAIL_ORDER_TYPE": "Bestelltyp",
  "RECOURSE_CAMPAIGN_DETAIL_OTHER_REVENUES": "sonstige Erlöse[€]",
  "RECOURSE_CAMPAIGN_DETAIL_OUTSTANDING_PARTIAL_PAYMENTS": "Teilzahlungen",
  "RECOURSE_CAMPAIGN_DETAIL_OUTSTANDING_REVENUES": "Ausstehende Erlöse[€]",
  "RECOURSE_CAMPAIGN_DETAIL_PARTSREQUEST": "Teileanforderung",
  "RECOURSE_CAMPAIGN_DETAIL_PARTSREQUEST_QPP": "Teileanforderung QPP",
  "RECOURSE_CAMPAIGN_DETAIL_PUBLISHED_DATE": "Veröffentl. Datum",
  "RECOURSE_CAMPAIGN_DETAIL_RECOURSE_REQUEST": "Regressforderung",
  "RECOURSE_CAMPAIGN_DETAIL_RECOURSE_REQUEST_CHANGE_DATE": "Regressforderung versendet",
  "RECOURSE_CAMPAIGN_DETAIL_REVENUES_CURRENT_BUSINESS_YEAR": "Erlöse aktuelles GJ[€]",
  "RECOURSE_CAMPAIGN_DETAIL_REVENUES_PREVIOUS_YEARS": "Erlöse Vorjahre[€]",
  "RECOURSE_CAMPAIGN_DETAIL_SUPPLIER": "Kreditor Nr.",
  "RECOURSE_CAMPAIGN_DETAIL_TABLE_BOOKING_ID": "Beleg-Nr.",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_AMOUNT": "Betrag",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_BOOKING_TYPE": "Buchungsart",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_CREDITOR": "Kreditor",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_CREDITOR_NO": "Kreditor-Nr.",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_DUE_DATE": "Fälligkeitsdatum",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_HEADLINE": "Teilzahlungen",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_STATE": "Status",
  "RECOURSE_CAMPAIGN_DETAIL_TABLEBOOKING_TOTAL_AMOUNT": "Gesamtwert[€]",
  "RECOURSE_CAMPAIGN_DETAIL_TARGET_CARS": "Betroffene Fzg",
  "RECOURSE_CAMPAIGN_DETAIL_TOPIC": "Thema",
  "RECOURSE_CAMPAIGN_DETAIL_TOTAL_REVENUES": "Erlöse gesamt[€]",
  "RECOURSE_CAMPAIGN_DETAIL_YEAR": "Geschäftsjahr",
  "RECOURSE_CAMPAIGN_OVERVIEW_TAB": "Übersicht",
  "RECOURSE_CAMPAIGN_TAB": "Aktionen",
  "RECOURSE_CAMPAIGN_TABLE_ASSIGNEE": "Bearb.",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_COSTS_PROGNOSIS": "Prog.",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_ORIGINAL": "Camp.Orig",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_RECOURSE_ID": "Akt.Nr.",
  "RECOURSE_CAMPAIGN_TABLE_CAMPAIGN_STATE_TYPE": "I/E",
  "RECOURSE_CAMPAIGN_TABLE_CREATE_DATE": "Dat.",
  "RECOURSE_CAMPAIGN_TABLE_FKCAMPAIGN_STATE_ID": "Status",
  "RECOURSE_CAMPAIGN_TABLE_FULFILLMENT_DEGREE": "Erf.grad",
  "RECOURSE_CAMPAIGN_TABLE_NAME1": "Kred.",
  "RECOURSE_CAMPAIGN_TABLE_OPERATION_ID": "V.Nr.",
  "RECOURSE_CAMPAIGN_TABLE_ORDER_TYPE": "Best.typ",
  "RECOURSE_CAMPAIGN_TABLE_RECOURSE_ACTUAL_COSTS": "Akt.kost.",
  "RECOURSE_CAMPAIGN_TABLE_SUPPLIER": "Kred.Nr.",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_ASSIGNEE": "Bearbeiter",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_COSTS_PROGNOSIS": "Prognosekosten Soll",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_ORIGINAL": "Original",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_RECOURSE_ID": "Aktionsnr.",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CAMPAIGN_STATE_TYPE": "Intern/Extern",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_CREATE_DATE": "Datum",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_FKCAMPAIGN_STATE_ID": "Status",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_FULFILLMENT_DEGREE": "Erfüllungsgrad[%]",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_NAME1": "Kreditor",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_OPERATION_ID": "Vorgangsnr.",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_ORDER_TYPE": "Bestelltyp",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_RECOURSE_ACTUAL_COSTS": "Aktionskosten Ist",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_SUPPLIER": "Kreditor Nr.",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_TOPIC": "Thema",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_TOTAL_REVENUE": "Gesamterlöse",
  "RECOURSE_CAMPAIGN_TABLE_TOOLTIP_YEAR": "Geschäftsjahr",
  "RECOURSE_CAMPAIGN_TABLE_TOPIC": "Th.",
  "RECOURSE_CAMPAIGN_TABLE_TOTAL_REVENUE": "Ges.Erl",
  "RECOURSE_CAMPAIGN_TABLE_YEAR": "Ges.jahr",
  "RECOURSE_CLAIM": "Regressforderung",
  "RECOURSE_CLAIM_DATE_OF_DISPATCH": "Regressforderung versendet",
  "RECOURSE_CLAIM_SEARCH": "Suche",
  "RECOURSE_CLAIM_SEARCH_ERROR_CONTENT": "Suche ist fehlgeschlagen",
  "RECOURSE_CLAIM_SEARCH_ERROR_TITLE": "Fehler",
  "RECOURSE_CLAIM_SEARCH_OBJECT_CRITERIA": "Objektkriterium",
  "RECOURSE_CLAIM_SEARCH_PART_NUMBER": "Teilenummer eingebaut",
  "RECOURSE_CLAIM_SEARCH_RECOURSE_STATE": "Regressstatus",
  "RECOURSE_CLAIM_TAB": "Antragsübersicht",
  "RECOURSE_CLAIM_TABLE_ACCEPTANCE_FACTOR": "Anerkennungsquote",
  "RECOURSE_CLAIM_TABLE_BARCODE": "Barcode",
  "RECOURSE_CLAIM_TABLE_CLAIM_ID": "Antragsnummer",
  "RECOURSE_CLAIM_TABLE_DEALER_NUMBER": "Händlernummer",
  "RECOURSE_CLAIM_TABLE_ID": "ID",
  "RECOURSE_CLAIM_TABLE_QUALITY_COMPLAINT_CLOSE_DATE": "Beanstandung Abschlussdatum",
  "RECOURSE_CLAIM_TABLE_QUOTA_RELEVANT": "Quotenrelevant",
  "RECOURSE_CLAIM_TABLE_RECOURSE_STATE": "Regressstatus",
  "RECOURSE_CLAIM_TABLE_SPARE_PART_NUMBER": "Teilenummer eingebaut",
  "RECOURSE_CLAIM_TABLE_SUPPLIER_NUMBER": "Lieferant",
  "RECOURSE_CLAIM_TABLE_VIN": "FIN",
  "recourseCriteria.comment": "Bemerkungsfeld",
  "recourseCriteria.commentInvalidCharacters": "Die Zeichen { } sind nicht erlaubt. < > sind nur um E-Mail-Adressen erlaubt.",
  "recourseCriteria.dealerNumber": "Händlernummer",
  "recourseCriteria.dealerNumberShort": "HP Nr",
  "recourseCriteria.id": "ID",
  "recourseCriteria.mileage": "Kilometerstand",
  "recourseCriteria.mileageShort": "KM",
  "recourseCriteria.objectCriteriaGroup": "Objektkriteriengruppe",
  "recourseCriteria.objectCriteriaGroupShort": "Obj.krit.gruppe",
  "recourseCriteria.recourseRelevant": "Regressrelevant",
  "recourseCriteria.recourseRelevantShort": "Regress",
  "recourseCriteria.sparePartNumber": "Teilenummer eingebaut",
  "recourseCriteria.sparePartNumberShort": "TNr. eingeb.",
  "recourseCriteria.supplierNumber": "Lieferantennummer",
  "recourseCriteria.supplierNumberShort": "Lieferant",
  "recourseCriteria.tab": "Regresskriterien",
  "recourseCriteria.validFrom": "Gültig (von)",
  "recourseCriteria.validTo": "Gültig (bis)",
  "recourseCriteria.warrantyCalculationMethod": "GW-Berechnungsmethode",
  "recourseCriteria.warrantyCalculationMethodShort": "GW-Berechnung",
  "recourseCriteria.warrantyDays": "GW-Tage",
  "recourseCriteria.warrantyDaysShort": "GW-Tage",
  "recourseState.DEBITED": "Belastet",
  "recourseState.NO_RECOURSE": "Kein Regress",
  "recourseState.OPEN": "Offen",
  "recourseState.OUT_OF_WARRANTY": "Außerhalb GW",
  "recourseState.PART_REQUESTED": "Teil angefordert",
  "recourseState.QUOTAS_ASSIGNED": "Quoten zugeordnet",
  "recourseState.READY_FOR_DEBIT": "Bereit für Belastung",
  "recourseState.WAITING_FOR_ANALYSIS": "Warten auf Analyse",
  "REFERENCE": "Referenz",
  "REFERENCE_BOOKINGS": "Referenzbuchungen",
  "REFERENCED_BOOKING_AMOUNT": "Nettowert",
  "REFERENCED_BOOKING_DUE_DATE": "Fälligkeit",
  "REFERENCED_BOOKING_ID": "Beleg-Nr.",
  "REFERENCED_BOOKING_STATUS": "Status",
  "REFERENCED_BOOKING_SUM_AMOUNT": "Gesamtwert",
  "REFERENCED_BOOKING_TYPE": "Buchungsart",
  "REJECT": "Ablehnung",
  "REJECT_APPROVAL_DIALOG_REJECT_COMMENT": "Ablehnung Bemerkung",
  "REJECT_BOOKING_FAILED": "Buchung {{0}} konnte nicht abgelehnt werden.",
  "REJECT_BOOKING_FAILED_MESSAGE": "Ablehnung fehlgeschlagen: Die Buchung {{0}} konnte nicht abgelehnt werden.",
  "REJECT_BOOKING_FAILED_TITLE": "Ablehnung fehlgeschlagen",
  "REJECT_BOOKING_MESSAGE": "Buchung abgelehnt: Buchung {{0}} wurde erfolgreich abgelehnt.",
  "REJECT_BOOKING_SUCCESSFUL": "Buchung {{0}} wurde erfolgreich abgelehnt.",
  "REJECT_BOOKING_TITLE": "Buchung abgelehnt",
  "REJECTED": "Abgelehnt",
  "REPLACEMENT_MOBILITY": "Ersatzmobilität",
  "REPORT_MODAL_TEXTFIELD_LABEL_SAVE": "Name der Ansicht",
  "REPROCESS_BOOKING_FAILED": "Buchung {{0}} kann nicht erneut verarbeitet werden.",
  "REPROCESS_BOOKING_SUCCESSFUL": "Buchung {{0}} wird freigegeben und erneut verarbeitet.",
  "REPROCESS_DIALOG_MESSAGE": "Die Buchung wird erneut verarbeitet. Wollen Sie wirklich fortfahren?",
  "REPROCESS_DIALOG_TITLE": "Erneut verarbeiten",
  "RESULTS": "Ergebnisse",
  "SALES_ORG_INVOICE_BLOCK": "Debitor für Faktura in Vertriebsorganisation gesperrt",
  "SALES_ORG_ORDER_BLOCK": "Debitor für Aufträge in Vertriebsorganisation gesperrt",
  "SAVE": "Speichern",
  "SAVE_ADDITIONAL_COST_ERROR_MESSAGE": "Zusatzkosten für Prüfbericht {{x}} konnten nicht gespeichert werden.",
  "SAVE_ADDITIONAL_COST_ERROR_TITLE": "Fehlerersparnis Zusatzkosten",
  "SAVE_ADDITIONAL_COST_SUCCESS_MESSAGE": "Zusatzkosten für Prüfbericht {{0}} wurden erfolgreich gespeichert.",
  "SAVE_ADDITIONAL_COST_SUCCESS_TITLE": "Zusatzkosten gespeichert",
  "SAVE_BOOKING_FAILED_MESSAGE": "Buchung konnte nicht gespeichert werden",
  "SAVE_BOOKING_FAILED_TITLE": "Buchung Fehlgeschlagen",
  "SAVE_ERROR_COST_RATE_ERROR_DUPLICATE_MESSAGE": "Fehlergrund {{0}} existiert bereits. Speichern nicht möglich.",
  "SAVE_ERROR_COST_RATE_ERROR_MESSAGE": "Fehlergrund {{0}} konnte nicht gespeichert werden",
  "SAVE_ERROR_COST_RATE_ERROR_TITLE": "Speichern fehlgeschlagen",
  "SAVE_ERROR_COST_RATE_SUCCESS_MESSAGE": "Fehlergrund {{0}} wurde erfolgreich gespeichert",
  "SAVE_ERROR_COST_RATE_SUCCESS_TITLE": "Fehlergrund gespeichert",
  "SAVED_CAMPAIGN_FAILED": "Aktion {{0}} konnte nicht gespeichert werden.",
  "SAVED_CAMPAIGN_SUCCESSFUL": "Aktion {{0}} erfolgreich gespeichert.",
  "SAVED_NEW_BOOKING_FAILED": "Buchung/en {{0}} konnte/n nicht gespeichert werden.",
  "SAVED_NEW_BOOKING_SUCCESSFUL": "Buchung/en {{0}} wurde/n erfolgreich gespeichert.",
  "SAVED_NEW_BOOKING_TITLE": "Gespeichert",
  "SAVED_SUCCESSFUL": "Erfolgreich gespeichert",
  "SAVED_TITLE": "Gespeichert",
  "SEARCH": "Suche",
  "SEARCH_CONFIGURATION": "Suchkonfiguration",
  "SEARCH_CRITERIA": "Suchkriterien",
  "SELECT_INVOICE_REASON": "Fakturagrund auswählen",
  "START_APPROVE_PROCESS_BUTTON": "Freigabeprozess starten",
  "STATUS_REASON_TEXT_PREFIX": "SAP-Fehlermeldung: ",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG": "Vorhandene Lieferantenausnahme überschreiben",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG_DELETE": "Löschen des Lieferantenausschlusses",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG_DELETE_MESSAGE": "Wollen Sie den Lieferantenausschluss für den Lieferanten {{0}} wirklich <br>löschen?",
  "SUPPLIER_EXCEPTIONS_CONFIRMATION_DIALOG_MESSAGE": "Sind Sie sicher, dass die Daten überschrieben werden sollen?",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_ERROR_MESSAGE": "Lieferantenausschluss von Lieferant {{0}} konnte nicht gelöscht werden.",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_ERROR_TITLE": "Löschen war nicht möglich, Fehler aufgetreten",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_MESSAGE": "Gespeichert - Lieferantenausschluss von Lieferant {{0}} wurde gelöscht.",
  "SUPPLIER_EXCEPTIONS_DIALOG_DELETED_TITLE": "Lieferantenausnahme gelöscht",
  "SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_FROM": "Ausschluss ab",
  "SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_REASON": "Begründung",
  "SUPPLIER_EXCEPTIONS_DIALOG_EXCLUSION_TILL": "Ausschluss bis",
  "SUPPLIER_EXCEPTIONS_DIALOG_NEW_BUTTON": "Neuen Lieranten ausschließen",
  "SUPPLIER_EXCEPTIONS_DIALOG_SAVED": "Gespeichert - Lieferantenausschluss für Lieferant {{0}} wurde gespeichert.",
  "SUPPLIER_EXCEPTIONS_DIALOG_SAVED_ERROR_MESSAGE": "Fehler - Speichern nicht möglich. Ausschlusslieferant existiert bereits.",
  "SUPPLIER_EXCEPTIONS_DIALOG_SUPPLIER_NUMBER": "Lieferanten Nr.",
  "SUPPLIER_EXCEPTIONS_DIALOG_TITLE": "Hinzufügen/Bearbeiten eines neuen Lieferantenausschlusses",
  "SUPPLIER_EXCEPTIONS_REASON": "Begründung",
  "SUPPLIER_EXCEPTIONS_TABLE_EXCLUSION_FROM": "Ausschluss ab",
  "SUPPLIER_EXCEPTIONS_TABLE_EXCLUSION_TILL": "Ausschluss bis",
  "SUPPLIER_EXCEPTIONS_TABLE_SUPPLIER": "Lieferant",
  "SUPPLIER_EXCEPTIONS_TABLE_SUPPLIER_ID": "Lieferanten Nr.",
  "SUPPLIER_NOT_FOUND_MESSAGE": "Lieferant existiert nicht oder kann nicht gefunden werden",
  "SUPPLIER_NOT_FOUND_TITLE": "Lieferant nicht gefunden",
  "SUPPLIER_SEARCH": "Lieferant",
  "SUPPLIER_UPDATE_TITLE": "Lieferant aktualisiert",
  "SUPPLIER_UPDATED_SUCCESSFUL": "Lieferant wurde erfolgreicht aktualisiert",
  "supplierAnalysisAcceptance.ACCEPTED": "Anerkannt",
  "supplierAnalysisAcceptance.REJECTED": "Abgelehnt",
  "supplierCondition.add": "Lieferantenkondition hinzufügen",
  "supplierCondition.createDate": "Erstelldatum",
  "supplierCondition.createDateShort": "Erstelldat.",
  "supplierCondition.delete.dialog.message": "Möchten Sie die ausgewählte Lieferantenbedingung wirklich löschen?",
  "supplierCondition.delete.dialog.title": "Lieferantenkondition löschen",
  "supplierCondition.delete.error.message": "Fehler beim Löschen der Lieferantenbedingung",
  "supplierCondition.delete.success.message": "Lieferantenbedingung erfolgreich gelöscht",
  "supplierCondition.handlingChargeCostsFactor": "Handling aus Antrag (%)",
  "supplierCondition.handlingChargeCostsFactorShort": "% Handling-C",
  "supplierCondition.handlingSupplierCostsFactor": "Handling Einkaufspreis (%)",
  "supplierCondition.handlingSupplierCostsFactorShort": "% Handling-L",
  "supplierCondition.laborCostsFactor": "Lohnkosten aus Antrag (%)",
  "supplierCondition.laborCostsFactorShort": "% Lohn",
  "supplierCondition.landingCostsFactor": "Landing aus Antrag (%)",
  "supplierCondition.landingCostsFactorShort": "% Landing",
  "supplierCondition.lastEditDate": "Änderungsdatum",
  "supplierCondition.lastEditDateShort": "Änderungsdat.",
  "supplierCondition.materialCostsFactor": "Materialkosten Einkaufspreis (%)",
  "supplierCondition.materialCostsFactorShort": "% Material",
  "supplierCondition.modalTitle": "Lieferantenkondition hinzufügen/bearbeiten",
  "supplierCondition.otherCosts": "Sonstige Kosten in Euro",
  "supplierCondition.otherCosts.placeholder": "0,00",
  "supplierCondition.otherCostsShort": "€ Sonstige Kosten",
  "supplierCondition.saveError.content": "Fehler beim Speichern der Lieferantenkondition",
  "supplierCondition.saveError.duplicateSupplier": "Hierfür besteht schon eine Lieferantenkondition",
  "supplierCondition.saveError.title": "Fehler",
  "supplierCondition.saveSuccess.content": "Lieferantenkondition gespeichert",
  "supplierCondition.saveSuccess.title": "Erfolg",
  "supplierCondition.supplierName": "Lieferantenname",
  "supplierCondition.supplierNameShort": "L-Name",
  "supplierCondition.supplierNumber": "Lieferantennummer",
  "supplierCondition.supplierNumberShort": "Lieferant",
  "supplierCondition.tab": "Lieferantenbedingungen",
  "supplierCondition.thirdPartyCostsFactor": "Fremdkosten aus Antrag (%)",
  "supplierCondition.thirdPartyCostsFactorShort": "% Fremdkosten",
  "supplierCondition.thirdPartyMaterialCostsFactor": "Fremdmaterialkosten (%)",
  "supplierCondition.thirdPartyMaterialCostsFactorShort": "% Fremdmat.",
  "TABLE_VIEW_DELETE_TABLE_VIEW": "Aktuelle Ansicht löschen",
  "TABLE_VIEW_EDIT_TABLE_VIEW": "Aktuelle Ansicht bearbeiten",
  "TABLE_VIEW_MODAL_CONFIRMATION_MESSAGE": "Standardansicht - Aktuelle Standardansicht '{{value}}' wird überschrieben.",
  "TABLE_VIEW_MODAL_DEFAULT_VIEW": "Standardansicht",
  "TABLE_VIEW_MODAL_DELETE_HEADER": "Aktuelle Ansicht löschen",
  "TABLE_VIEW_MODAL_DELETE_MESSAGE": "Die ausgewählte Ansicht '{{value}}' wird gelöscht, möchten Sie fortfahren?",
  "TABLE_VIEW_MODAL_METADATA_CHANGED": "Metadaten der Tabelle wurden geändert. Speichern?",
  "TABLE_VIEW_MODAL_TEXTFIELD_LABEL_EDIT": "Neuer Name der Ansicht",
  "TABLE_VIEW_MODAL_TITLE_EDIT": "Aktuelle Ansicht ändern",
  "TABLE_VIEW_MODAL_TITLE_SAVE": "Aktuelle Ansicht speichern",
  "TABLE_VIEW_RESET_TABLE_VIEW_DEFAULT": "Ansicht zurücksetzen (benutzerdefinierter Standard)",
  "TABLE_VIEW_RESET_TABLE_VIEW_SYSTEM_DEFAULT": "Ansicht zurücksetzen (Systemstandard)",
  "TABLE_VIEW_SAVE_TABLE_VIEW": "Ansicht speichern",
  "TABLE_VIEW_SAVE_TABLE_VIEW_TITLE": "Aktuelle Ansicht speichern",
  "TABLE_VIEW_SELECT_LABEL": "Ansicht",
  "TABLE_VIEW_SYSTEM_DEFAULT": "Systemstandard",
  "TABLE_VIEW_VALIDATOR_ALREADY_EXISTS": "Name existiert bereits",
  "TABLE_VIEW_VALIDATOR_ENTER_NAME": "Name der Ansicht angeben",
  "TABLE_VIEW_VALIDATOR_INVALID_CHARACTERS": "Ungültiges Zeichen",
  "TABLE_VIEW_VALIDATOR_MAX_LENGTH": "Maximale Länge (50 Zeichen) überschritten",
  "TABLE_VIEW_VALIDATOR_NOT_ALLOWED": "Netter Versuch. Nicht erlaubt!",
  "TITLE_APPROVAL": "Freigegeben",
  "TITLE_APPROVAL_WORKFLOW": "Freigabeprozess gestartet",
  "TITLE_BOOKING_CANCELED": "Booking cancelled",
  "TITLE_DELETE_ATTACHMENT": "Anhang gelöscht",
  "TITLE_FAILED": "Fehlgeschlagen",
  "TITLE_REJECT": "Abgelehnt",
  "TITLE_REPROCESS": "Erneut verarbeitet",
  "TITLE_SAVED": "Gespeichert",
  "TITLE_UPLOAD_ATTACHMENT": "Anhang hochgeladen",
  "UPLOAD_ATTACHMENT": "Anhang hochladen",
  "UPLOAD_ATTACHMENT_CHOOSE": "Datei auswählen",
  "UPLOAD_ATTACHMENT_FAILED": "Anhang {{0}} konnte nicht hochgeladen werden.",
  "UPLOAD_ATTACHMENT_FILE_SIZE": "Die maximale Dateigröße von 15MB wurde überschritten.",
  "UPLOAD_ATTACHMENT_ONLY_PDF_MESSAGE": "Nur .pdf kann extern sein",
  "UPLOAD_ATTACHMENT_RECEIVER": "Empfänger",
  "UPLOAD_ATTACHMENT_RECEIVER_EXTERN": "Extern",
  "UPLOAD_ATTACHMENT_RECEIVER_INTERN": "Intern",
  "UPLOAD_ATTACHMENT_SUCCESSFUL": "Anhang {{0}} wurde erfolgreich hochgeladen.",
  "UPLOAD_ATTACHMENT_TITLE": "Anhang hochladen",
  "UPLOAD_FAILED_TITLE": "Hochladen fehlgeschlagen",
  "VALIDATION_INPUT_REQUIRED": "Pflichtfeld",
  "validation.message.pattern": "Dieser Wert ist ungültig",
  "validation.message.required": "Dieser Wert ist erforderlich",
  "warrantyCalculationMethod.CUSTOMER_DELIVERY": "Start: Auslieferungsdatum",
  "warrantyCalculationMethod.ZP8": "Start: ZP8/Gefahrübergang",
  "WIDGET_SELECT_NO_RESULT_TEXT": "kein Ergebnis",
  "WIDGET_SELECT_PLACEHOLDER": "Bitte auswählen oder eingeben",
  "YES": "Ja",
  "yesno.no": "Nein",
  "yesno.yes": "Ja"
}
